import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IInvoice } from '../../models/invoices/Invoices';
import { IndexedDbService } from '../../services/indexeddb.service';
import { environment } from '../../../environments/environment';
import { paymentProcessService } from '../../services/payment-process.service';

@Component({
  selector: 'app-invoice-summary',
  templateUrl: './invoice-summary.component.html',
  styleUrls: ['./invoice-summary.component.css']
})
export class InvoiceSummaryComponent implements OnInit {
  @Input() token: string = 'initial token!';
  selectedInvoices: Array<IInvoice> = new Array();
  pendingAmountToPay: number = 0;
  paymentType: string = "fullAmount";
  totalEditedAmount: number = 0;
  currency: any;

  constructor(private router: Router, private route: ActivatedRoute, private indexedDbService: IndexedDbService, private paymentProcessService: paymentProcessService) {
    let aToken = localStorage.getItem('azuretoken');
    this.token = aToken != null ? JSON.parse(aToken) : '';    
  }

  ngOnInit(): void {
    this.paymentProcessService.setSelectedPaymentMethod('');
    let selectedInvoicesInStorage = localStorage.getItem("InvoiceList")
    try {
      if(!!selectedInvoicesInStorage) {
        let parsedInvoices = JSON.parse(selectedInvoicesInStorage)
        this.selectedInvoices = Array.isArray(parsedInvoices) ? parsedInvoices : parsedInvoices?.invoices
        for (let i = 0; i < this.selectedInvoices.length; i++) {
          const selInvoice = this.selectedInvoices[i];
          this.currency = selInvoice.currency
          this.pendingAmountToPay += +selInvoice.pending_amount;          
        }
      }
      else throw Error("No invoices selected to pay")
    } catch (error) {
      console.log(error)
      this.cancel()     
    }
  }

  getTotalAmount() {
    this.totalEditedAmount = this.selectedInvoices.map(a => parseFloat(a.editedAmountToPay)).reduce((x, y) => x + y, 0);;
    return this.totalEditedAmount;
  }

  cancel() {
    localStorage.removeItem("InvoiceList")
    this.router.navigate(["../"], { relativeTo: this.route });
  }

  async payBills() {
    if(!environment.newPaymentExperienceEnableFlag){
      this.indexedDbService.deleteInvoices(this.selectedInvoices[0].bpNo)
    }
    console.log(this.selectedInvoices)
    localStorage.setItem("InvoiceList", JSON.stringify(this.selectedInvoices));
    this.router.navigate(["../checkout"], { relativeTo: this.route });
  }

}
